ecWindowManager.$inject = ['$rootScope', '$compile', '$timeout'];

export default function ecWindowManager($rootScope, $compile, $timeout) {
  const eWindows = findOrCreateEwcWindows();
  return {
    open,
  };

  function findOrCreateEwcWindows() {
    const eFound = document.querySelector('ewc-windows');
    if (eFound) {
      return eFound;
    }
    const eWindowsNewCreated = document.createElement('ewc-windows');
    eWindowsNewCreated.setAttribute('taskbar', 'condensed');
    document.body.appendChild(eWindowsNewCreated);
    return eWindowsNewCreated;
  }

  /**
   * Permite abrir una nueva ventana.
   *
   * @param {object} data Los datos para crear la ventana, detalle:
   * @param {string} [data.template] El contenido de la ventana
   * @param {string} [data.label] El titulo de la ventana
   * @param {string} [data.icon] El icono de la ventana.
   * @param {string} [data.id] el id de la ventana
   * @param {object} [data.scope] Objeto de datos del scope angularjs. Nota que por retro compatibilitad debería pasarse un objeto { params: { ...mis datos..} }
   * @param {number} [data.width] El ancho de la ventana en pixels, ej: 550
   * @param {number} [data.height] El altura de la ventana en pixels, ej: 500
   * @param {string} [data.title] DEPRECATED, usar `data.label` El titulo de la ventana. Se mantiene por retrocompatibilidad.
   * @param {object} [data.params] DEPRECATED, usar `data.scope`. Objeto de datos del scope angularjs, en `scope.params`.
   * @returns {Promise}
   */
  function open(data) {
    // const { title = '', template = '', scope = null, width, height } = data;
    return eWindows.open(data).then(eWindow => {
      const unbinds = [];

      return new Promise(resolve => {
        const newScope = $rootScope.$new(true);
        const { id = eWindow.id, params = {}, scope = params } = data;
        const retrocompatibilidad = { id, params };
        Object.assign(newScope, retrocompatibilidad, scope);

        eWindow.setAttribute('ec-loader', 'true');

        const api = {
          id: eWindow.id,
          maximize: eWindow.maximize,
          minimize: eWindow.minimize,
          restore: eWindow.restore,
          close: eWindow.close,
        };

        unbinds.push(() => newScope.$destroy());

        eWindow.addEventListener('EwcWindow:destroy', onDestroy);
        unbinds.push(() => {
          data.onDestroy && data.onDestroy();
          eWindow.removeEventListener('EwcWindow:destroy', onDestroy);
        });

        $compile(eWindow.firstElementChild)(newScope);
        $timeout(() => {
          eWindow.removeAttribute('ec-loader');
          resolve(api);
        });
      });

      function onDestroy() {
        unbinds.forEach(fn => fn());
      }
    });
  }
}
